import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import {
  Training,
  Home,
  Login,
  Profile,
  Associations,
  Banner,
  UnitDetails,
  MyProfile,
  PrivacyPolicy,
  TrainingSheet,
} from "./pages";
import { useAuth } from "./contexts/auth";
import { BottomTab } from "./components";
import {
  AssociationsProvider,
  BannersProvider,
  PromotionsProvider,
  UnitsProvider,
} from "./contexts";
import Units from "./pages/units";
import { TrainingProvider } from "./contexts/training";

function Routes() {
  return (
    <Router>
      <Switch>
        <OnlyLoggedOffRoute path="/login">
          <Login />
        </OnlyLoggedOffRoute>
        <PrivateRoute exact path="/">
          <Home />
        </PrivateRoute>

        <PrivateRoute path="/associations">
          <Associations />
        </PrivateRoute>

        <PrivateRoute path="/training">
          <Training />
        </PrivateRoute>

        <PrivateRoute exact path="/units">
          <Units />
        </PrivateRoute>
        <PrivateRoute exact path="/units/:unitId">
          <UnitDetails />
        </PrivateRoute>

        <PrivateRoute exact path="/profile">
          <Profile />
        </PrivateRoute>
        <PrivateRoute path="/profile/my-profile">
          <MyProfile />
        </PrivateRoute>
        <PrivateRoute path="/profile/privacy-policy">
          <PrivacyPolicy />
        </PrivateRoute>
        <PrivateRoute path="/profile/training-sheet">
          <TrainingSheet />
        </PrivateRoute>

        <PrivateRoute exact path="/banner/:bannerId">
          <Banner />
        </PrivateRoute>

        <PrivateRoute path="*">
          <Redirect to="/" />
        </PrivateRoute>
      </Switch>
    </Router>
  );
}

function PrivateRoute({ children, ...rest }: any) {
  const { isLogged } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLogged ? (
          <UnitsProvider>
            <AssociationsProvider>
              <PromotionsProvider>
                <BannersProvider>
                  <TrainingProvider>
                    <div
                      style={{
                        height: "calc(100% - 4rem)",
                        display: "flex",
                        flexDirection: "column",
                        overflowY: "auto",
                      }}
                    >
                      {children}
                    </div>
                    <BottomTab location={location} />
                  </TrainingProvider>
                </BannersProvider>
              </PromotionsProvider>
            </AssociationsProvider>
          </UnitsProvider>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
function OnlyLoggedOffRoute({ children, ...rest }: any) {
  const { isLogged } = useAuth();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isLogged ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default Routes;
